<template>
  <div
    v-if="$canAndRulesPass(user, 'card.create')"
    class="create-card-page"
  >
    <div class="create-card-content">
      <div class="spinner"></div>
      <h2>Создаем карту целей</h2>
      <p>
        Пожалуйста, подождите. Это может занять несколько секунд.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import requestSender from '@/api/base/requestSender';

export default {
  name: 'auto-create-card',
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {
    this.createCard();
  },
  methods: {
    createCard() {
      const userId = parseInt(this.$route.params.id);

      requestSender('post', 'auto-create-card/create', {
        userId,
      })
        .then((data) => {
          if (data.new_card_id > 0) {
            this.$router.replace(`/card/${data.new_card_id}`);
          } else {
            this.errorCreateCard();
          }
        })
        .catch(() => {
          this.errorCreateCard();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    errorCreateCard() {
      this.$notify.error({
        title: 'Ошибка',
        message: 'Не удалось создать карту целей.',
      });
      this.$router.replace('/');
    }
  },
};
</script>

<style scoped lang="scss">
  .create-card-page {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
  }

  .create-card-page {
    .create-card-content {
      text-align: center;
      max-width: 420px;
    }

    .create-card-content h2 {
      margin: 20px 0 10px;
    }

    .create-card-content p {
      color: #6b7280;
    }

    .spinner {
      width: 56px;
      height: 56px;
      margin: 0 auto;
      border: 4px solid #e5e7eb;
      border-top-color: #CE0037;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  }
</style>